import { NgModule, Optional, SkipSelf } from '@angular/core';
import { AccountIntegStatusService } from './services/account-integ-status.service';
import { AccountsService } from './services/accounts.service';
import { AdminService } from './services/admin.service';
import { AppInfoService } from './services/app-info.service';
import { AppStateService } from './services/app-state.service';
import { AppUserClaimsService } from './services/app-user-claims.service';
import { ChildCommsService } from './services/child-comms.service';
import { ClaimsGuard } from './guards/claims.guard';
import { IframeSpaLogoutGuard } from './guards/iframe-spa-logout.guard';
import { PartnerAdminGuard } from './guards/partner-admin.guard';
import { SupportPortalGuard } from './guards/support-portal.guard';
import { SupportPortalService } from './services/support-portal.service';
import { UsersService } from './services/users.service';
import { TemplateManagementGuard } from './guards/template-management.guard';
import { MiVBManagementGuard } from './guards/mivb-management.guard';
import { MiVBAccountSettingsService } from './services/mivb-account-settings.service';
import { AsyncJobsService } from './services/async-jobs.service';
import { FeatureFlagsGuard } from './guards/feature-flags.guard';
import { PBXSettingsManagementGuard } from './guards/pbx-settings-management.guard';

@NgModule({
    providers: [
        AccountIntegStatusService,
        AccountsService,
        AdminService,
        AppInfoService,
        AppStateService,
        AppUserClaimsService,
        ChildCommsService,
        ClaimsGuard,
        IframeSpaLogoutGuard,
        PartnerAdminGuard,
        SupportPortalGuard,
        FeatureFlagsGuard,
        SupportPortalService,
        UsersService,
        TemplateManagementGuard,
        MiVBManagementGuard,
        MiVBAccountSettingsService,
        AsyncJobsService,
        PBXSettingsManagementGuard
    ],
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
      if (parentModule) {
        throw new Error(
          'CoreModule is already loaded. Import it in the AppModule only'
        );
      }
    }
  }